
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M24.42 19.03l16.55 16.55M35.58 40.97L19.03 24.42M33.656 56.224l-6.81-6.81L49.431 26.83l6.81 6.81z"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M52.45 37.43l6.05 6.05L43.48 58.5l-6.05-6.05M26.344 3.77l6.81 6.81-22.585 22.584-6.81-6.81z"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M7.55 22.57L1.5 16.52 16.52 1.5l6.05 6.05"}})])
          )
        }
      }
    